import Ad from './Ad';

class NonMraidAd extends Ad {
  constructor({ src }) {
    super({ src });
  }
}

export default NonMraidAd;
